import { ASSURANCE_CHECK_FIELD_ID, ASSURANCE_CHECK_FIELD_ID_TYPE } from './image_metadata_constants';
import { SCOPE } from './sort_constants';

export enum ASSURANCE_CHECK_RUN_TIME {
  PRO_ACTIVE = 'pro_active',
  PRE_SUBMISSION = 'pre_submission',
  POST_SUBMISSION = 'post_submission'
}

export type AssuranceCheckRunTime = `${ASSURANCE_CHECK_RUN_TIME}`;

export interface AssuranceCheckConfig {
  assuranceCheckRunTime: AssuranceCheckRunTime;
  visibleToSubmitter: boolean;
  sendPushNotification: boolean;
  visible_for_tab?: SCOPE[];
}

/**
 * Configuration for assurance check behaviors
 * Defines when checks run, visibility to submitters, and push notification settings
 */
export const ASSURANCE_CHECK_CONFIG: Record<ASSURANCE_CHECK_FIELD_ID_TYPE, AssuranceCheckConfig> = {
  [ASSURANCE_CHECK_FIELD_ID.ITEMIZED_MEAL_RECEIPT_CHECK]: {
    assuranceCheckRunTime: ASSURANCE_CHECK_RUN_TIME.PRO_ACTIVE,
    visibleToSubmitter: true,
    sendPushNotification: true,
    visible_for_tab: [SCOPE.DELEGATE, SCOPE.ME, SCOPE.TEAM]
  },
  [ASSURANCE_CHECK_FIELD_ID.FAKE_RECEIPT_DETECTION]: {
    assuranceCheckRunTime: ASSURANCE_CHECK_RUN_TIME.PRE_SUBMISSION,
    visibleToSubmitter: false,
    sendPushNotification: false,
    visible_for_tab: [SCOPE.TEAM]
  },
  [ASSURANCE_CHECK_FIELD_ID.ALCOHOL_DETECTION]: {
    assuranceCheckRunTime: ASSURANCE_CHECK_RUN_TIME.PRE_SUBMISSION,
    visibleToSubmitter: false,
    sendPushNotification: false,
    visible_for_tab: [SCOPE.DELEGATE, SCOPE.ME, SCOPE.TEAM]
  },
  [ASSURANCE_CHECK_FIELD_ID.VENDOR_LEGITIMACY]: {
    assuranceCheckRunTime: ASSURANCE_CHECK_RUN_TIME.PRE_SUBMISSION,
    visibleToSubmitter: false,
    sendPushNotification: false,
    visible_for_tab: [SCOPE.TEAM]
  },
  [ASSURANCE_CHECK_FIELD_ID.AMOUNT_ANOMALY_DETECTION]: {
    assuranceCheckRunTime: ASSURANCE_CHECK_RUN_TIME.PRE_SUBMISSION,
    visibleToSubmitter: false,
    sendPushNotification: false,
    visible_for_tab: [SCOPE.TEAM]
  },
  [ASSURANCE_CHECK_FIELD_ID.EXCESSIVE_TIP_DETECTION]: {
    assuranceCheckRunTime: ASSURANCE_CHECK_RUN_TIME.PRE_SUBMISSION,
    visibleToSubmitter: false,
    sendPushNotification: false,
    visible_for_tab: [SCOPE.DELEGATE, SCOPE.ME, SCOPE.TEAM]
  },
  [ASSURANCE_CHECK_FIELD_ID.OUTSIDE_BUSINESS_HOURS]: {
    assuranceCheckRunTime: ASSURANCE_CHECK_RUN_TIME.POST_SUBMISSION,
    visibleToSubmitter: false,
    sendPushNotification: false,
    visible_for_tab: [SCOPE.DELEGATE, SCOPE.ME, SCOPE.TEAM]
  },
  [ASSURANCE_CHECK_FIELD_ID.LINE_ITEM_MISMATCH]: {
    assuranceCheckRunTime: ASSURANCE_CHECK_RUN_TIME.POST_SUBMISSION,
    visibleToSubmitter: false,
    sendPushNotification: false,
    visible_for_tab: [SCOPE.DELEGATE, SCOPE.ME, SCOPE.TEAM]
  }
};
